import { render, staticRenderFns } from "./CreateRealworksCredentialsForm.vue?vue&type=template&id=3b1adaff&"
import script from "./CreateRealworksCredentialsForm.vue?vue&type=script&lang=ts&"
export * from "./CreateRealworksCredentialsForm.vue?vue&type=script&lang=ts&"
import style0 from "./CreateRealworksCredentialsForm.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports